import { queryOptions, useQuery } from '@tanstack/react-query';

import type { IHttpClient } from '../../api/client.js';
import { useHttpClient } from '../../api/HttpClientContext.js';
import {
  getOfficialEvaluationTenant,
  type OfficialEvaluationTenant,
} from '../../services/officialEvaluationTenantService.js';

const officialEvaluationTenantKey = ['officialEvaluationTenant'] as const;

function officialEvaluationTenantQuery(client: IHttpClient) {
  return queryOptions({
    queryKey: officialEvaluationTenantKey,
    queryFn: (): Promise<OfficialEvaluationTenant> =>
      getOfficialEvaluationTenant(client),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export interface UseOfficialEvaluationTenantResult {
  data: OfficialEvaluationTenant | undefined;
  isLoading: boolean;
  error: Error | null;
}

export function useOfficialEvaluationTenant(): UseOfficialEvaluationTenantResult {
  const client = useHttpClient();
  const query = useQuery(officialEvaluationTenantQuery(client));

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
